import { trackError } from '@iheartjane/tracking';
import type { Address } from '@iheartjane/types';
import { Storage } from '@iheartjane/utils';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CustomerThunkAction } from '@jane/monolith/customer/customerAction';
import { PosCartSource } from '@jane/monolith/sources/posCart';
import type { PosCart } from '@jane/shared/types';

export const getPosCart = (): CustomerThunkAction => (dispatch, getState) => {
  const {
    cart: {
      cart: { uuid, id, products, store },
    },
  } = getState();

  dispatch(initiateGetPosCart());

  const deliveryAddress = Storage.get<Address | null>('deliveryAddress');

  if (!uuid) {
    trackError('Cannot fetch PosCart without a cart uuid', {
      uuid,
      id,
      productCount: products.length,
      storeId: store?.id,
    });

    return;
  }

  return PosCartSource.get(deliveryAddress, uuid).then(
    (result) => dispatch(getPosCartSuccess(result)),
    (err) => dispatch(getPosCartError(err))
  );
};

export type PosCartActions =
  | ReturnType<typeof initiateGetPosCart>
  | ReturnType<typeof getPosCartSuccess>
  | ReturnType<typeof getPosCartError>;

export type PosCartState = {
  isLoading: boolean;
  posCart: PosCart;
};

const getInitialState = (): PosCartState => ({
  posCart: {
    totals: null,
  },
  isLoading: false,
});

const posCartSlice = createSlice({
  name: 'posCart',
  initialState: getInitialState(),
  reducers: {
    initiateGetPosCart: (state) => {
      return { ...state, isLoading: true };
    },
    getPosCartSuccess: (
      state,
      action: PayloadAction<{ pos_cart: PosCart }>
    ) => {
      return { ...state, posCart: action.payload.pos_cart, isLoading: false };
    },
    getPosCartError: (state) => {
      return { ...state, isLoading: false };
    },
  },
  selectors: {
    selectPosCart: (state) => state,
  },
});

export const {
  actions: { initiateGetPosCart, getPosCartSuccess, getPosCartError },
  reducer: posCartReducer,
  selectors: { selectPosCart },
} = posCartSlice;
